import type { RootLogic } from 'models';
import { createContext } from 'react';

export const RootContext = createContext({} as RootLogic);
